export default [
  {
    faction: 'castle',
    factionCn: '城堡',
    creatures: [
      {
        text: '戟兵',
        value: 'halberdier',
      },
      {
        text: '神射手',
        value: 'marksman',
      },
      {
        text: '皇家狮鹫',
        value: 'royalGriffin',
      },
      {
        text: '十字军',
        value: 'crusader',
      },
      {
        text: '祭祀',
        value: 'zealot',
      },
      {
        text: '骑士',
        value: 'champion',
      },
      {
        text: '大天使',
        value: 'archangel',
      },
    ]
  },
  {
    faction: 'rampart',
    factionCn: '壁垒',
    creatures: [
      {
        text: '半人马首领',
        value: 'centaurCaptain',
      },
      {
        text: '战斗矮人',
        value: 'battleDwarf',
      },
      {
        text: '大精灵',
        value: 'grandElf',
      },
      {
        text: '银飞马',
        value: 'silverPegasus',
      },
      {
        text: '枯木战士',
        value: 'dendroidSoldier',
      },
      {
        text: '独角神兽',
        value: 'warUnicorn',
      },
      {
        text: '金龙',
        value: 'goldDragon',
      },
    ]
  },
  {
    faction: 'tower',
    factionCn: '塔楼',
    creatures: [
      {
        text: '大妖精',
        value: 'masterGremlin',
      },
      {
        text: '石像怪',
        value: 'obsidianGargoyle',
      },
      {
        text: '铁人',
        value: 'ironGolem',
      },
      {
        text: '大法师',
        value: 'archMage',
      },
      {
        text: '神怪主',
        value: 'masterGenie',
      },
      {
        text: '蛇妖',
        value: 'nagaQueen',
      },
      {
        text: '泰坦巨人',
        value: 'titan',
      },
    ]
  },
  {
    faction: 'inferno',
    factionCn: '地狱',
    creatures: [
      {
        text: '怪物',
        value: 'familiar',
      },
      {
        text: '玛各',
        value: 'magog',
      },
      {
        text: '三首猎犬',
        value: 'cerberus',
      },
      {
        text: '长角恶鬼',
        value: 'hornedDemon',
      },
      {
        text: '邪神王',
        value: 'pitLord',
      },
      {
        text: '烈火精灵',
        value: 'efreetSultan',
      },
      {
        text: '大恶魔',
        value: 'archDevil',
      },
    ]
  },
  {
    faction: 'necropolis',
    factionCn: '墓园',
    creatures: [
      {
        text: '骷髅勇士',
        value: 'skeletonWarrior',
      },
      {
        text: '僵尸',
        value: 'zombie',
      },
      {
        text: '阴魂',
        value: 'wraith',
      },
      {
        text: '吸血鬼王',
        value: 'vampireLord',
      },
      {
        text: '尸巫王',
        value: 'powerLich',
      },
      {
        text: '恐怖骑士',
        value: 'dreadKnight',
      },
      {
        text: '鬼龙',
        value: 'ghostDragon',
      },
    ]
  },
  {
    faction: 'dungeon',
    factionCn: '地下城',
    creatures: [
      {
        text: '地狱洞穴人',
        value: 'infernalTroglodyte',
      },
      {
        text: '鹰身女巫',
        value: 'harpyHag',
      },
      {
        text: '毒眼',
        value: 'evilEye',
      },
      {
        text: '美杜莎女王',
        value: 'medusaQueen',
      },
      {
        text: '牛头王',
        value: 'minotaurKing',
      },
      {
        text: '毒蝎狮',
        value: 'scorpicore',
      },
      {
        text: '黑龙',
        value: 'blackDragon',
      },
    ]
  },
  {
    faction: 'stronghold',
    factionCn: '据点',
    creatures: [
      {
        text: '大耳怪王',
        value: 'hobgoblin',
      },
      {
        text: '恶狼斗士',
        value: 'wolfRaider',
      },
      {
        text: '半兽人首领',
        value: 'orcChieftain',
      },
      {
        text: '食人魔王',
        value: 'ogreMage',
      },
      {
        text: '雷鸟',
        value: 'thunderbird',
      },
      {
        text: '独眼王',
        value: 'cyclopsKing',
      },
      {
        text: '比蒙巨兽',
        value: 'ancientBehemoth',
      },
    ]
  },
  {
    faction: 'fortress',
    factionCn: '要塞',
    creatures: [
      {
        text: '大狼人',
        value: 'gnollMarauder',
      },
      {
        text: '蜥蜴勇士',
        value: 'lizardWarrior',
      },
      {
        text: '龙蝇',
        value: 'dragonFly',
      },
      {
        text: '巨蜥',
        value: 'greaterBasilisk',
      },
      {
        text: '蛮牛',
        value: 'mightyGorgon',
      },
      {
        text: '飞龙王',
        value: 'wyvernMonarch',
      },
      {
        text: '终极九头怪',
        value: 'chaosHydra',
      },
    ]
  },
  {
    faction: 'conflux',
    factionCn: '元素',
    creatures: [
      {
        text: '精灵',
        value: 'sprite',
      },
      {
        text: '雷元素',
        value: 'stormElemental',
      },
      {
        text: '冰元素',
        value: 'iceElemental',
      },
      {
        text: '烈火元素',
        value: 'energyElemental',
      },
      {
        text: '石元素',
        value: 'magmaElemental',
      },
      {
        text: '魔法元素',
        value: 'magicElemental',
      },
      {
        text: '凤凰',
        value: 'phoenix',
      },
    ]
  },
  {
    faction: 'cove',
    factionCn: '港口',
    creatures: [
      {
        text: '海洋之灵',
        value: 'oceanid',
      },
      {
        text: '海员',
        value: 'seaman',
      },
      {
        text: '皇家海盗',
        value: 'seaDog',
      },
      {
        text: '暴风雕',
        value: 'ayssid',
      },
      {
        text: '海洋术士',
        value: 'sorceress',
      },
      {
        text: '鱼人勇士',
        value: 'nixWarrior',
      },
      {
        text: '深渊海蛇',
        value: 'haspid',
      },
    ]
  },
  {
    faction: 'neutral',
    factionCn: '中立',
    creatures: [
      {
        text: '农民',
        value: 'peasant',
      },
      {
        text: '水晶龙',
        value: 'crystalDragon',
      },
    ]
  },
  // {
  //   faction: 'courtyard',
  //   factionCn: '庭院',
  //   creatures: [
  //   ]
  // },
]
